import * as defaultImport from "styled-components";
export * from "styled-components";
export default defaultImport.default;
